import ResizebleDrawer from './HOClevel'

export default ResizebleDrawer
